export enum SCREEN_VARIANT {
    MOBILE = 'MOBILE',
    TABLET = 'TABLET',
    DESKTOP = 'DESKTOP'
}

export enum SCREEN_MEDIA_QUERIES {
    TABLET = 768,
    DESKTOP = 1180
}